import React, {useState} from 'react';
import { Form, Input, Button, Card, Alert } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useGlobal } from '../../System/Global/GlobalProvider';
import { useNavigate } from 'react-router-dom';
import { FiCode } from 'react-icons/fi';


const LoginPage = () => {

     const { authenticate, getCode } = useGlobal();
     const navigate = useNavigate();
     const [error, setError] = useState(null);
     const [ code, setCode ] = useState(null);


    const onFinish = async (values) => {

        console.log('values', values)

        if (values.verificationCode) {

            if (+values.verificationCode === +code) {

                const loginSuccess = await authenticate(values.username);

                if(loginSuccess) {
            
                navigate('/')
    
                } else {
    
                    setError("Invalid username or password.");
                }
            } else {

                setError("Invalid verification code.");
            }

        } else {

            const verify = await getCode(values.username);

            if(verify) {
            
                setCode(verify)
    
            } else {
    
                setError("Invalid username.");
            }

        }

    };

    return (
     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f5f5f5' }}>
            <Card style={{ width: '500px' }}>
            <div style={{textAlign: 'center', backgroundColor: '#27368C', paddingBottom: 10}}>
                    <img style={{ width: 200, marginTop: 15 }} src="/images/opexlogo.png" alt="Clean Bees"/>
                    {/* <h2 style={{margin: 0}}>Login</h2> */}
                    {error && <Alert message={error} type="error" showIcon style={{ margin: 15 }} />}
                </div>
                { code && <Alert message="Please check your email for the verification code." type="info" showIcon style={{ margin: 15 }} /> }
                <Form
                    name="login_form"
                    layout="vertical"
                    onFinish={onFinish}
                    style={{ background: '#fff', padding: '24px', borderRadius: '8px' }}
                >
                    <Form.Item
                        label="Email"
                        name="username"
                        rules={[{ type: 'email', message: 'The input is not valid email!' }]}
                    >
                        <Input prefix={<UserOutlined />} placeholder="Username" />
                    </Form.Item>
                    
                    { code &&
                    <Form.Item
                        label="Verification code"
                        name="verificationCode"
                        rules={[{ required: true, message: 'Please input your verification code!' }]}
                    >
                        <Input prefix={<FiCode />} placeholder="Verification Code" />
                    </Form.Item>
                    }

                    <Form.Item>
                        <Button style={{height: 45, marginTop: 10}} type="primary" htmlType="submit" block>
                            Log in
                        </Button>
                    </Form.Item>
                    <Form.Item style={{ textAlign: 'center' }}>
                         {/* Don't have an account? <Link to="/signup">Signup</Link> */}
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
}

export default LoginPage;
